import MuiGrid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';

// Keep the primitive on MUI v6 Grid2 so consumers use the stable `size` API consistently.
export const StyledGrid = styled(MuiGrid)({}) as typeof MuiGrid;
